import React from 'react';
import { Text } from '@charlietango/ui';
import { rem } from '../../styles/rem';

import { TextVariant } from '../../styles/typography';
import { colors } from '../../styles/colors';

type PartyDetailsType = {
  label: React.ReactNode;
  ariaValue?: string;
  value: React.ReactNode;
};
export const itemStyle = {
  pb: 2,
  margin: 0,
};

function PartyDetailsItem({ label, value, ariaValue }: PartyDetailsType) {
  return (
    <dl sx={itemStyle}>
      <Text
        as="dt"
        variant={TextVariant.HeaderSm}
        sx={{
          color: colors.base.Text.Secondary,
          flex: '0 0 auto',
          mr: 4,
        }}
      >
        {label}
      </Text>
      <Text
        as="dd"
        variant={TextVariant.BodyLg}
        sx={{
          flex: '1 1 auto',
          color: colors.base.Text.Primary,
          fontSize: [rem(18), rem(18), rem(18), rem(20)],
          lineHeight: 1.2,
          a: {
            textDecoration: 'none',
            textUnderlineOffset: rem(3),
            transition: 'color 0.2s ease, text-decoration-color 0.2s ease',
            '&:hover, &:focus-visible': {
              color: colors.base.Text.Brand,
              textDecoration: 'underline',
            },
          },
        }}
        aria-label={ariaValue}
      >
        {value}
      </Text>
    </dl>
  );
}
export default PartyDetailsItem;
